<template>
  <div>
    <div class="box">
      <div class="edm-left"></div>
      <div class="edm">
        <div class="top-con-box">
          <div class="logo-pic"></div>
          <div class="banner-con">
            <div class="title-box">
              <p>數據自助分析套件</p>
              <div class="subTitle">Tip Biu BI個人版，免費體驗！</div>
              <div class="click-btn">            
                <a href="https://escloud.digiwincloud.com/omp-web/#/home?edm=free">Click Me</a>
                </div>
            </div>
            <div class="tip"></div>
          </div>
          
        </div>
        <div class="con-box">
          <p>Tip Biu BI來助力，迎來大改變！</p>
        </div>
        <div class="list-box">
          <div class="li-co">
            <div class="left-1 left-co"></div>
            <div class="right-co co-1"><span>無需掌握編程</span>，即可製作出高大上的圖表！</div>
          </div>
           <div class="li-co">
            <div class="left-2 left-co"></div>
            <div class="right-co co-2"><span>支援上傳EXCEL及Google 表格等多源數據</span>，方便統一利用！</div>
          </div>
          <div class="li-co">
            <div class="left-3 left-co"></div>
            <div class="right-co co-3"><span>強大的數據分析能力</span>，讓你不再畏懼老闆的螺旋式提問！</div>
          </div>
           <div class="li-co">
            <div class="left-4 left-co"></div>
            <div class="right-co co-4"><span>智能預警提醒</span>，第一時間發現異常，即刻處理問題！</div>
          </div>
           <div class="li-co">
            <div class="left-5 left-co"></div>
            <div class="right-co co-5"><span>多終端</span>（PC端、移動端）同步，隨時隨地查看數據圖表！</div>
          </div>
          <div class="li-co">
            <div class="left-6 left-co"></div>
            <div class="right-co co-6"><span>快速搞定數據分析</span>，每天早早下班，不用加班製作圖表！</div>
          </div>
        </div>
        <div class="bottom-box">
          <div class="bot-left">
            <div class="title">如此簡單易用、智能高效的產品，不來試一試嗎？</div>
            <div class="click-btn"><a href="https://escloud.digiwincloud.com/omp-web/#/home?edm=free">Click Me</a>
              <div class="tips">即刻開啟免費體驗</div>
            </div>
          </div>
          <div class="bot-right"></div>
        </div>
        <div class="bottom-icon"></div>
      </div>
      <div class="edm-right"></div>
    </div>
  </div>
</template>
<script>
import FreeTryButton from "@/components/common/FreeTryButton.vue";
import FreeTry from "@/components/common/FreeTry.vue";
export default {
  components: {
    FreeTryButton,
    FreeTry
  },
  name: "Edm",
  data() {
    return {
      freeTryVisible: false
    };
  },
  methods: {
    getVisible(visible) {
      this.freeTryVisible = visible;
    }
  }
};
</script>
<style scoped>
.edm-left {
  width: 50px;
  height: 1px;
  float: left;
}
.edm-right {
  width: 50px;
  height: 1px;
  float: right;
}
.edm {
  width: 1200px;
  height: 135vh;
  margin: 0 auto;
  color: #f5f8fa;
  border: none;
  font-family: PingFang-SC-Bold, "\5FAE\8F6F\96C5\9ED1", "\9ED1\4F53",
    "\5B8B\4F53";
  font-size: 14px;
  position: relative;
}
.top-con-box{
  width: 1200px;
  height: 530px;
  background: url("../../static/img/bg.png") no-repeat center;
  background-size: 100% 100%;
  margin-bottom: 30px;
}
.logo-pic {
  background: url("../assets/img/logo.png") no-repeat;
  width: 240px;
  height: 42px;
  background-size: 90% 90%;
  position: relative;
  top: 30px;
  left: 35px;
}
.banner-con{
  display: flex;
  justify-content: flex-start;
}
.title-box {
  /* position: relative; */
}
.title-box p,.subTitle{
  font-size: 50px;
  color: #fff;
  margin-top: 56px;
  margin-left: 40px;
}
.subTitle{
  margin-top: 0px;
}
.tip{
  width: 409px;
  height: 303px;
  background: url("../../static/img/tip.png") no-repeat;
  background-size: 100% 100%;
  margin-top: 50px;
  margin-left: 40px;
}
.click-btn{
  width: 200px;
  height: 60px;
  background-color: #fff;
  border-radius: 8px;
  margin-left: 40px;
  margin-top: 60px;
  color: #0000DD;
  font-size: 24px;
  text-align: center;
  line-height: 60px;
  font-weight: bold;
  cursor: pointer;
}
.con-box p{
  font-size: 40px;
  text-align: center;
  margin-top: 60px;
  color: #333;
}
.list-box{
  margin-top: 40px;
  padding: 0 40px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.li-co{
  width: 350px;
  height: 110px;
  border-radius: 10px;
  box-shadow: 0px 2px 6px 0px rgba(197,197,197,0.5);
  margin-right: 35px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 20px;
  margin-top: 20px;
}
.li-co:nth-child(3n){
   margin-right: 0px;
}
.left-co {
  width: 50px;
  height: 50px;
}
.left-1{
  background: url("../../static/img/1.png") no-repeat center;
  background-size: 100% 100%;

}
.left-2{
  background: url("../../static/img/2.png") no-repeat center;
  background-size: 100% 100%;
}
.left-3{
  background: url("../../static/img/3.png") no-repeat center;
  background-size: 100% 100%;
}
.left-4{
  background: url("../../static/img/4.png") no-repeat center;
  background-size: 100% 100%;
}
.left-5{
  background: url("../../static/img/5.png") no-repeat center;
  background-size: 100% 100%;
}
.left-6{
  background: url("../../static/img/6.png") no-repeat center;
  background-size: 100% 100%;
}
.right-co{
  font-size: 18px;
  color: #666;
  text-align: justify;
  margin-left: 10px;
  width: 250px;
}
.co-1 span{
  color: #21CDD6;
}
.co-2 span{
  color: #B77FF1;
}
.co-3 span{
  color: #6D93FE;
}
.co-4 span{
  color: #EA8CDA ;
}
.co-5 span{
  color: #F9A460;
}
.co-6 span{
  color: #7DD142;
}
.bottom-box{
  margin-top: 120px;
  display: flex;
  justify-content: space-between;
}
.bot-left{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.bot-left .title{
  color: #333;
  font-size: 30px;
  width: 455px;
  margin-left: 78px;
  text-align: center;
}
.bot-left .click-btn{
  width: 200px;
  height: 60px;
  border: 1px solid #0000DD;
  border-radius: 8px;
  font-size: 24px;
  color: #0000DD;
  text-align: center;
  line-height: 62px;
  margin-top: 30px;
  cursor: pointer;
}
.bot-left .click-btn .tips {
  font-size: 20px;
  color: #666;
  font-weight: normal;
  margin-top: -10px;
}
.bot-right{
  width: 535px;
  height: 377px;
  background: url("../../static/img/computer.png")no-repeat center;
  background-size: 100% 100%;
}
.bottom-icon{
  width: 237px;
  height: 155px;
  background: url("../../static/img/bottom.png") no-repeat center;
  background-size: 100% 100%;
  position: relative;
  bottom: 100px;
}
a {
   color: #0000DD !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Edm.vue